import api from "@/lib/api";
import { toast } from "sonner";

// Téléchargement d'un PDF authentifié (cookie httpOnly) via blob.
export const downloadPdf = async (path, filename) => {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Reçu indisponible");
  }
};
